/**
 * Bundle builder: pick 2 paid items (dolls and/or cloths), then one free rattle.
 */
(function () {
  function formatMoney(cents, format) {
    var c = Number(cents);
    if (Number.isNaN(c)) c = 0;
    var amount = (c / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(c / 100));
    var withComma = amount.replace('.', ',');
    if (!format) return '$' + amount;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma);
  }

  function getVariantFromCard(card) {
    var sel = card.querySelector('[data-bundle-variant-select]');
    var price;
    var compare = null;
    var id;
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt || opt.disabled) return null;
      id = opt.value;
      price = parseInt(opt.getAttribute('data-price-cents'), 10);
      var cc = opt.getAttribute('data-compare-cents');
      if (cc) compare = parseInt(cc, 10);
    } else {
      id = card.getAttribute('data-default-variant-id');
      price = parseInt(card.getAttribute('data-price-cents'), 10);
      var c2 = card.getAttribute('data-compare-cents');
      if (c2) compare = parseInt(c2, 10);
    }
    if (!id || Number.isNaN(price)) return null;
    return { id: id, priceCents: price, compareCents: compare };
  }

  function cardTitle(card) {
    var t = card.querySelector('.bundle-builder__card-title');
    return t ? t.textContent.trim() : '';
  }

  function cardImageSrc(card) {
    var img = card.querySelector('.bundle-builder__card-img--primary, .bundle-builder__card-img');
    return img && img.currentSrc ? img.currentSrc : img && img.src ? img.src : '';
  }

  function updateFreeRattlePriceDisplay(card, cfg) {
    var wrap = card.querySelector('[data-bundle-compare-wrap]');
    if (!wrap) return;
    var v = getVariantFromCard(card);
    if (!v) return;
    var fmt = cfg.currencyCodeEnabled ? cfg.moneyWithCurrencyFormat : cfg.moneyFormat;
    var strike = v.compareCents && v.compareCents > v.priceCents ? v.compareCents : v.priceCents;
    wrap.innerHTML = '<s>' + formatMoney(strike, fmt) + '</s>';
  }

  function syncCardDatasetFromSelect(card) {
    var sel = card.querySelector('[data-bundle-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    card.setAttribute('data-default-variant-id', opt.value);
    card.setAttribute('data-price-cents', opt.getAttribute('data-price-cents') || '0');
    var cc = opt.getAttribute('data-compare-cents');
    if (cc) card.setAttribute('data-compare-cents', cc);
    else card.removeAttribute('data-compare-cents');
    if (card.getAttribute('data-kind') === 'rattle') {
      var cfgEl = document.querySelector(
        '[data-bundle-builder-config="' + card.closest('[data-bundle-builder]').dataset.sectionId + '"]'
      );
      if (cfgEl) {
        try {
          updateFreeRattlePriceDisplay(card, JSON.parse(cfgEl.textContent));
        } catch (e) {}
      }
    }
  }

  function syncCartAfterBundleAdd() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-builder', cartData: cart });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      })
      .catch(function () {});
  }

  function pickLimitMessage(S, required) {
    return (S.pickLimit || 'You can only choose {{ count }} from this step.').replace(
      /\{\{\s*count\s*\}\}/g,
      String(required)
    );
  }

  function initBundleBuilder(root) {
    if (root.dataset.bundleBuilderInit === '1') return;
    root.dataset.bundleBuilderInit = '1';

    var sectionId = root.getAttribute('data-section-id');
    var cfgEl = document.querySelector('[data-bundle-builder-config="' + sectionId + '"]');
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    var S = cfg.strings;
    var required = Math.max(1, parseInt(cfg.requiredPicks, 10) || 2);
    var progressTotal = required + 1;

    var state = {
      picks: [],
      rattle: null,
    };

    var els = {
      progressFill: root.querySelector('[data-bundle-progress-fill]'),
      progressLabel: root.querySelector('[data-bundle-progress-label]'),
      progressCount: root.querySelector('[data-bundle-progress-count]'),
      mask: root.querySelector('[data-bundle-step3-mask]'),
      gridRattle: root.querySelector('[data-bundle-grid="rattle"]'),
      lockBadge: root.querySelector('[data-bundle-step3-lock-badge]'),
      freeBadge: root.querySelector('[data-bundle-step3-free-badge]'),
      savings: root.querySelector('[data-bundle-savings]'),
      savingsTitle: root.querySelector('[data-bundle-savings-title]'),
      subPicks: root.querySelector('[data-bundle-sub-picks]'),
      linePicksLabel: root.querySelector('[data-bundle-line-picks-label]'),
      subRattle: root.querySelector('[data-bundle-sub-rattle]'),
      total: root.querySelector('[data-bundle-total]'),
      cta: root.querySelector('[data-bundle-cta]'),
      ctaLabel: root.querySelector('[data-bundle-cta-label]'),
      toast: root.querySelector('[data-bundle-toast]'),
      toastMsg: root.querySelector('[data-bundle-toast-msg]'),
    };

    var fmt = cfg.currencyCodeEnabled ? cfg.moneyWithCurrencyFormat : cfg.moneyFormat;
    var toastTimer;

    function showToast(msg) {
      if (!els.toast || !els.toastMsg) return;
      els.toastMsg.textContent = msg;
      els.toast.hidden = false;
      els.toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        els.toast.classList.remove('is-visible');
        els.toast.hidden = true;
      }, 2400);
    }

    function isPaidKind(kind) {
      return kind === 'doll' || kind === 'cloth';
    }

    function slotEyebrowForCard(card, index) {
      var kind = card.getAttribute('data-kind');
      if (kind === 'doll' && S.slot1Label) return S.slot1Label;
      if (kind === 'cloth' && S.slot2Label) return S.slot2Label;
      var base = S.slotPickLabel || 'Your pick';
      return base + (required > 1 ? ' ' + (index + 1) : '');
    }

    function selectPaidCard(card) {
      var kind = card.getAttribute('data-kind');
      if (!isPaidKind(kind) || card.classList.contains('bundle-builder__card--disabled')) return;

      var idx = state.picks.indexOf(card);
      if (idx >= 0) {
        state.picks.splice(idx, 1);
        state.rattle = null;
        refresh();
        return;
      }

      if (state.picks.length >= required) {
        showToast(pickLimitMessage(S, required));
        return;
      }

      state.picks.push(card);
      state.rattle = null;
      refresh();
      showToast(cardTitle(card));
    }

    function selectRattleCard(card) {
      if (state.picks.length < required) return;
      if (state.rattle === card) {
        state.rattle = null;
      } else {
        root.querySelectorAll('[data-bundle-card][data-kind="rattle"]').forEach(function (c) {
          c.classList.remove('bundle-builder__card--selected');
          c.setAttribute('aria-pressed', 'false');
        });
        state.rattle = card;
        card.classList.add('bundle-builder__card--selected');
        card.setAttribute('aria-pressed', 'true');
      }
      refresh();
      if (state.rattle === card) showToast(cardTitle(card) + ' — ' + S.free);
    }

    function sumPicksCents() {
      var sum = 0;
      state.picks.forEach(function (card) {
        var v = getVariantFromCard(card);
        if (v) sum += v.priceCents;
      });
      return sum;
    }

    function refresh() {
      var picks = state.picks;
      var rattle = state.rattle;
      var picksReady = picks.length >= required;
      var complete = picksReady && rattle;

      root.querySelectorAll('[data-bundle-card]').forEach(function (c) {
        var k = c.getAttribute('data-kind');
        var on =
          (isPaidKind(k) && picks.indexOf(c) >= 0) || (k === 'rattle' && rattle === c);
        c.classList.toggle('bundle-builder__card--selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (els.mask) {
        if (picksReady) els.mask.setAttribute('hidden', '');
        else els.mask.removeAttribute('hidden');
      }
      if (els.gridRattle) {
        els.gridRattle.classList.toggle('is-unlocked', picksReady);
      }
      if (els.lockBadge && els.freeBadge) {
        if (picksReady) {
          els.lockBadge.setAttribute('hidden', '');
          els.freeBadge.removeAttribute('hidden');
        } else {
          els.lockBadge.removeAttribute('hidden');
          els.freeBadge.setAttribute('hidden', '');
        }
      }

      var slotRattle = root.querySelector('[data-bundle-slot="rattle"]');
      if (slotRattle) slotRattle.style.opacity = picksReady ? '1' : '0.55';

      var emptyPick = S.slotEmptyPick || S.slotEmptyDoll || 'Not selected yet';
      for (var i = 0; i < required; i++) {
        var slotKey = 'pick-' + i;
        var slot = root.querySelector('[data-bundle-slot="' + slotKey + '"]');
        var mini = root.querySelector('[data-bundle-mini="' + slotKey + '"]');
        var name = root.querySelector('[data-bundle-name="' + slotKey + '"]');
        var price = root.querySelector('[data-bundle-slot-price="' + slotKey + '"]');
        var rm = root.querySelector('[data-bundle-remove="' + slotKey + '"]');
        var eyebrow = root.querySelector('[data-bundle-slot-eyebrow="' + slotKey + '"]');
        if (!slot || !mini || !name || !price || !rm) continue;

        var card = picks[i];
        if (card) {
          slot.classList.add('bundle-builder__slot--filled');
          mini.classList.remove('bundle-builder__slot-mini--empty');
          var src = cardImageSrc(card);
          mini.innerHTML = src
            ? '<img src="' + src + '" alt="" width="80" height="80" loading="lazy" />'
            : '';
          name.textContent = cardTitle(card);
          name.classList.remove('bundle-builder__slot-name--dim');
          rm.hidden = false;
          var v = getVariantFromCard(card);
          if (v) price.textContent = formatMoney(v.priceCents, fmt);
          if (eyebrow) eyebrow.textContent = slotEyebrowForCard(card, i);
        } else {
          slot.classList.remove('bundle-builder__slot--filled');
          mini.classList.add('bundle-builder__slot-mini--empty');
          mini.innerHTML = '';
          name.classList.add('bundle-builder__slot-name--dim');
          name.textContent = emptyPick;
          price.textContent = S.subtotalDash;
          rm.hidden = true;
          if (eyebrow) {
            eyebrow.textContent =
              (S.slotPickLabel || 'Your pick') + (required > 1 ? ' ' + (i + 1) : '');
          }
        }
      }

      fillRattleSlot();

      function fillRattleSlot() {
        var mini = root.querySelector('[data-bundle-mini="rattle"]');
        var name = root.querySelector('[data-bundle-name="rattle"]');
        var price = root.querySelector('[data-bundle-slot-price="rattle"]');
        var rm = root.querySelector('[data-bundle-remove="rattle"]');
        var slot = root.querySelector('[data-bundle-slot="rattle"]');
        if (!slot || !mini || !name || !price || !rm) return;

        if (rattle) {
          slot.classList.add('bundle-builder__slot--filled');
          mini.classList.remove('bundle-builder__slot-mini--empty');
          var src = cardImageSrc(rattle);
          mini.innerHTML = src
            ? '<img src="' + src + '" alt="" width="80" height="80" loading="lazy" />'
            : '';
          name.textContent = cardTitle(rattle);
          name.classList.remove('bundle-builder__slot-name--dim');
          rm.hidden = false;
          price.innerHTML = '<span class="bundle-builder__slot-price--free">' + S.free + '</span>';
        } else {
          slot.classList.remove('bundle-builder__slot--filled');
          mini.classList.add('bundle-builder__slot-mini--empty');
          mini.innerHTML = '';
          name.classList.add('bundle-builder__slot-name--dim');
          name.textContent = picksReady ? S.slotEmptyRattle : S.slotLockedRattle;
          price.innerHTML = '<span class="bundle-builder__slot-price--free">' + S.free + '</span>';
          rm.hidden = true;
        }
      }

      var picksCents = sumPicksCents();
      var rattleCents = 0;
      if (rattle) {
        var rv = getVariantFromCard(rattle);
        if (rv) rattleCents = rv.priceCents;
      } else if (picksReady && els.gridRattle) {
        var first = els.gridRattle.querySelector('[data-bundle-card]');
        if (first) {
          var fv = getVariantFromCard(first);
          if (fv) rattleCents = fv.priceCents;
        }
      }

      if (els.linePicksLabel) {
        els.linePicksLabel.textContent = S.linePicksLabel || 'Your picks';
      }
      if (els.subPicks) {
        els.subPicks.textContent = picks.length ? formatMoney(picksCents, fmt) : S.subtotalDash;
      }
      if (els.subRattle) {
        els.subRattle.textContent = complete ? S.free : picksReady ? S.progressRattle : S.free;
      }
      if (els.total) els.total.textContent = formatMoney(picksCents, fmt);

      if (els.savings) {
        if (complete) {
          els.savings.hidden = false;
          if (els.savingsTitle) {
            els.savingsTitle.textContent =
              S.savingsPrefix + ' — ' + formatMoney(rattleCents, fmt) + ' ' + S.savingsSuffix;
          }
        } else {
          els.savings.hidden = true;
          if (els.savingsTitle) els.savingsTitle.textContent = S.savingsIncomplete;
        }
      }

      var count = picks.length + (rattle ? 1 : 0);
      if (els.progressFill) els.progressFill.style.width = (count / progressTotal) * 100 + '%';
      if (els.progressCount) els.progressCount.textContent = count + ' / ' + progressTotal;

      if (els.progressLabel) {
        if (count === 0) {
          els.progressLabel.textContent = S.progressStart;
        } else if (picks.length < required) {
          var left = required - picks.length;
          els.progressLabel.textContent = (S.progressMore || 'Pick one more item').replace(
            /\{\{\s*count\s*\}\}/g,
            String(left)
          );
        } else if (!rattle) {
          els.progressLabel.textContent = S.progressRattle;
        } else {
          els.progressLabel.textContent = S.progressDone;
        }
      }

      if (els.cta) els.cta.disabled = !complete;
      if (els.ctaLabel) {
        if (complete) els.ctaLabel.textContent = S.ctaAdd;
        else if (picks.length === 0) els.ctaLabel.textContent = S.ctaStart;
        else if (picks.length < required) {
          var leftCta = required - picks.length;
          els.ctaLabel.textContent = (S.ctaMore || S.progressMore || 'Pick one more item').replace(
            /\{\{\s*count\s*\}\}/g,
            String(leftCta)
          );
        } else els.ctaLabel.textContent = S.ctaRattle;
      }
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-bundle-card]');
      if (card && root.contains(card)) {
        if (e.target.closest('[data-bundle-variant-select]')) return;
        var kind = card.getAttribute('data-kind');
        if (kind === 'rattle') selectRattleCard(card);
        else selectPaidCard(card);
        return;
      }

      var rm = e.target.closest('[data-bundle-remove]');
      if (rm && root.contains(rm)) {
        var key = rm.getAttribute('data-bundle-remove');
        if (key === 'rattle') {
          state.rattle = null;
        } else if (key && key.indexOf('pick-') === 0) {
          var pickIdx = parseInt(key.replace('pick-', ''), 10);
          if (!Number.isNaN(pickIdx) && state.picks[pickIdx]) {
            var removed = state.picks[pickIdx];
            state.picks.splice(pickIdx, 1);
            state.rattle = null;
            removed.classList.remove('bundle-builder__card--selected');
            removed.setAttribute('aria-pressed', 'false');
          }
        }
        refresh();
        return;
      }

      if (e.target.closest('[data-bundle-cta]')) {
        if (state.picks.length < required || !state.rattle || els.cta.disabled) return;

        var bid =
          typeof crypto !== 'undefined' && crypto.randomUUID
            ? crypto.randomUUID()
            : 'bb-' + Date.now();

        var items = state.picks.map(function (card, i) {
          var v = getVariantFromCard(card);
          return {
            id: Number(v.id),
            quantity: 1,
            properties: {
              _bundle_builder_id: bid,
              _bundle_builder_step: card.getAttribute('data-kind'),
              _bundle_builder_pick: String(i + 1),
            },
          };
        });

        var rv = getVariantFromCard(state.rattle);
        items.push({
          id: Number(rv.id),
          quantity: 1,
          properties: {
            _bundle_builder_id: bid,
            _bundle_builder_step: 'rattle',
          },
        });

        els.cta.disabled = true;
        els.cta.classList.add('loading');
        var url = cfg.cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        var useThemeDrawer = !!cfg.openThemeCartDrawer;
        var payload = { items: items };
        if (useThemeDrawer) {
          payload.sections = 'cart-drawer,cart-icon-bubble';
          payload.sections_url = cfg.sectionsUrl || window.location.pathname;
        }

        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (response) {
            if (response.status) {
              var msg = response.message || response.description;
              if (Array.isArray(msg)) msg = msg.join(' ');
              if (typeof msg === 'object' && msg !== null) msg = S.addError;
              showToast(msg || S.addError);
              return;
            }
            showToast(S.bundleAdded);
            if (useThemeDrawer) {
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
                drawer.renderContents(response);
              } else {
                syncCartAfterBundleAdd();
              }
            } else {
              syncCartAfterBundleAdd();
            }
          })
          .catch(function () {
            showToast(S.addError);
          })
          .finally(function () {
            if (els.cta) els.cta.classList.remove('loading');
            refresh();
          });
      }
    });

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-bundle-variant-select]');
      if (!sel || !root.contains(sel)) return;
      var card = sel.closest('[data-bundle-card]');
      if (!card) return;
      syncCardDatasetFromSelect(card);
      if (state.picks.indexOf(card) >= 0 || state.rattle === card) refresh();
    });

    root.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('[data-bundle-card]');
        if (!card || !root.contains(card)) return;
        if (e.target.closest('[data-bundle-variant-select]')) return;
        e.preventDefault();
        var kind = card.getAttribute('data-kind');
        if (kind === 'rattle') selectRattleCard(card);
        else selectPaidCard(card);
      },
      true
    );

    refresh();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  });
})();
